/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: R99muOTbbJZX

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { ApiProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/ApiProvider/ApiProvider"; // plasmic-import: TpJbGLILoYYl/codeComponent
import NewsItemPlaceholder from "../../NewsItemPlaceholder"; // plasmic-import: mztNva3rOCPX/component
import NewsItem from "../../NewsItem"; // plasmic-import: pB3fVf-A_mDL/component
import NewsDivider from "../../NewsDivider"; // plasmic-import: 00m9pZZCXFel/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicNews.module.css"; // plasmic-import: R99muOTbbJZX/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

import { dayjs as __fn_dayjs } from "@myevaluations/myevals-plasmic-utils/dist/custom-functions/dayjs"; // plasmic-import: dayjs/customFunction

createPlasmicElementProxy;

export type PlasmicNews__VariantMembers = {};
export type PlasmicNews__VariantsArgs = {};
type VariantPropType = keyof PlasmicNews__VariantsArgs;
export const PlasmicNews__VariantProps = new Array<VariantPropType>();

export type PlasmicNews__ArgsType = {};
type ArgPropType = keyof PlasmicNews__ArgsType;
export const PlasmicNews__ArgProps = new Array<ArgPropType>();

export type PlasmicNews__OverridesType = {
  newsExcerpts?: Flex__<"section">;
  link?: Flex__<"a"> & Partial<LinkProps>;
  img?: Flex__<typeof PlasmicImg__>;
  newsProvider?: Flex__<typeof ApiProvider>;
  content2?: Flex__<"div">;
  title?: Flex__<"h2">;
  news?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  newsItemPlaceholder?: Flex__<typeof NewsItemPlaceholder>;
  newsItem?: Flex__<typeof NewsItem>;
  newsDivider?: Flex__<typeof NewsDivider>;
  button?: Flex__<typeof Button>;
};

export interface DefaultNewsProps {
  className?: string;
}

const $$ = {
  dayjs: __fn_dayjs
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicNews__RenderFunc(props: {
  variants: PlasmicNews__VariantsArgs;
  args: PlasmicNews__ArgsType;
  overrides: PlasmicNews__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"newsExcerpts"}
      data-plasmic-override={overrides.newsExcerpts}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.newsExcerpts
      )}
    >
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? false
            : true
      ) ? (
        <PlasmicLink__
          data-plasmic-name={"link"}
          data-plasmic-override={overrides.link}
          aria-label={"Home"}
          className={classNames(projectcss.all, projectcss.a, sty.link)}
          component={Link}
          href={`/`}
          platform={"nextjs"}
          title={"Home"}
        >
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"29.831px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"170.666px"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/aaa816ed07b668d50951fc51e9c19c16.svg",
              fullWidth: 170.666,
              fullHeight: 29.831,
              aspectRatio: 5.7
            }}
          />
        </PlasmicLink__>
      ) : null}
      <ApiProvider
        data-plasmic-name={"newsProvider"}
        data-plasmic-override={overrides.newsProvider}
        alertOnError={true}
        className={classNames("__wab_instance", sty.newsProvider)}
        editorMode={
          hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? "success"
            : "success"
        }
        enabled={true}
        method={"GET"}
        name={"news"}
        path={"/New/Api.ashx?path=/marketing/news"}
        previewData={[
          {
            title: "Case Study: Predicting Board Passing Rate",
            description:
              'Predicting Board Exam Success with Auto-Assigned Rotation-Specific Quizzes in MyEvaluations<br type="_moz" />\r\n',
            date: "2024-03-11T19:00:17.660-04:00",
            url: "https://dev.myevaluations.com/Download/NewsAndEvents/Meharry Case Study Predict Board Pass Rate.pdf"
          },
          {
            title: "MyAnonymousReporting",
            description:
              "The easy way for all members of your institution to anonymously report incidents with associated photos and videos.",
            date: "2020-02-26T21:29:56.677-05:00",
            url: "https://dev.myevaluations.com/Download/NewsAndEvents/MyAnonymousReporting_Brochure.pdf"
          },
          {
            title:
              "Case Study: Streamlining the Onboarding & Credentialing Process",
            description:
              "Streamlining the Onboarding and Credentialing Process with MyEvaluations.com",
            date: "2024-03-11T19:31:29.070-04:00",
            url: "https://dev.myevaluations.com/Download/NewsAndEvents/Streamlining the Onboarding and Credentialing.pdf"
          },
          {
            title: "Case Study: Managing Med/Peds",
            description:
              "Integrated Approach Centralizes Reporting for a Combined Residency Program",
            date: "2015-12-12T19:17:48.220-05:00",
            url: "https://dev.myevaluations.com/Download/NewsAndEvents/UHC_Case MP Case Study CAW.pdf"
          },
          {
            title: "Self-evaluation",
            description:
              "To Thine Own Self Be Good, To Thine Own Self Be Sure, To Thine Own Self Be True, And To Thine Own Self Be Better",
            date: "2024-03-11T19:31:44.660-04:00",
            url: "https://dev.myevaluations.com/Download/NewsAndEvents/Self-Evaluation_To_Thine_Own_Self_Be_Good_To_Thine.pdf"
          }
        ]}
        refetchIfStale={true}
        refetchOnReconnect={false}
        refetchOnWindowFocus={false}
        retryOnError={true}
        suspense={false}
      >
        <DataCtxReader__>
          {$ctx => (
            <div
              data-plasmic-name={"content2"}
              data-plasmic-override={overrides.content2}
              className={classNames(projectcss.all, sty.content2)}
            >
              <h2
                data-plasmic-name={"title"}
                data-plasmic-override={overrides.title}
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.title
                )}
              >
                {"Latest Documents"}
              </h2>
              <div
                data-plasmic-name={"news"}
                data-plasmic-override={overrides.news}
                className={classNames(projectcss.all, sty.news)}
              >
                {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                  (() => {
                    try {
                      return $ctx.news.data || [0, 1, 2];
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()
                ).map((__plasmic_item_0, __plasmic_idx_0) => {
                  const currentItem = __plasmic_item_0;
                  const currentIndex = __plasmic_idx_0;
                  return (
                    <div
                      data-plasmic-name={"freeBox"}
                      data-plasmic-override={overrides.freeBox}
                      className={classNames(projectcss.all, sty.freeBox)}
                      key={currentIndex}
                    >
                      {(
                        hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? (() => {
                              try {
                                return $ctx.news.isLoading && !$ctx.news.data;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })()
                          : (() => {
                              try {
                                return $ctx.news.isLoading && !$ctx.news.data;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })()
                      ) ? (
                        <NewsItemPlaceholder
                          data-plasmic-name={"newsItemPlaceholder"}
                          data-plasmic-override={overrides.newsItemPlaceholder}
                          className={classNames(
                            "__wab_instance",
                            sty.newsItemPlaceholder
                          )}
                        />
                      ) : null}
                      {(
                        hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? (() => {
                              try {
                                return $ctx.news.data;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })()
                          : (() => {
                              try {
                                return $ctx.news.data;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })()
                      ) ? (
                        <NewsItem
                          data-plasmic-name={"newsItem"}
                          data-plasmic-override={overrides.newsItem}
                          className={classNames("__wab_instance", sty.newsItem)}
                          date={(() => {
                            try {
                              return $$.dayjs(currentItem.date).format(
                                "MMM DD, YYYY"
                              );
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                          description={(() => {
                            try {
                              return currentItem.description.replace(
                                /<[^>]*>?/gm,
                                ""
                              );
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                          downloadUrl={(() => {
                            try {
                              return currentItem.url;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                          title={(() => {
                            try {
                              return currentItem.title;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        />
                      ) : null}
                      {(
                        hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? (() => {
                              try {
                                return (() => {
                                  const news = $ctx.news.data;
                                  return news
                                    ? !(news.length - 1 === currentIndex)
                                    : currentIndex != 2;
                                })();
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })()
                          : (() => {
                              try {
                                return (() => {
                                  const news = $ctx.news.data;
                                  return news
                                    ? !(news.length - 1 === currentIndex)
                                    : currentIndex != 2;
                                })();
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })()
                      ) ? (
                        <NewsDivider
                          data-plasmic-name={"newsDivider"}
                          data-plasmic-override={overrides.newsDivider}
                          className={classNames(
                            "__wab_instance",
                            sty.newsDivider
                          )}
                        />
                      ) : null}
                    </div>
                  );
                })}
              </div>
              {false ? (
                <Button
                  data-plasmic-name={"button"}
                  data-plasmic-override={overrides.button}
                  className={classNames("__wab_instance", sty.button)}
                  color={"sky"}
                  size={"medium"}
                >
                  {"OLDER NEWS"}
                </Button>
              ) : null}
            </div>
          )}
        </DataCtxReader__>
      </ApiProvider>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  newsExcerpts: [
    "newsExcerpts",
    "link",
    "img",
    "newsProvider",
    "content2",
    "title",
    "news",
    "freeBox",
    "newsItemPlaceholder",
    "newsItem",
    "newsDivider",
    "button"
  ],
  link: ["link", "img"],
  img: ["img"],
  newsProvider: [
    "newsProvider",
    "content2",
    "title",
    "news",
    "freeBox",
    "newsItemPlaceholder",
    "newsItem",
    "newsDivider",
    "button"
  ],
  content2: [
    "content2",
    "title",
    "news",
    "freeBox",
    "newsItemPlaceholder",
    "newsItem",
    "newsDivider",
    "button"
  ],
  title: ["title"],
  news: ["news", "freeBox", "newsItemPlaceholder", "newsItem", "newsDivider"],
  freeBox: ["freeBox", "newsItemPlaceholder", "newsItem", "newsDivider"],
  newsItemPlaceholder: ["newsItemPlaceholder"],
  newsItem: ["newsItem"],
  newsDivider: ["newsDivider"],
  button: ["button"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  newsExcerpts: "section";
  link: "a";
  img: typeof PlasmicImg__;
  newsProvider: typeof ApiProvider;
  content2: "div";
  title: "h2";
  news: "div";
  freeBox: "div";
  newsItemPlaceholder: typeof NewsItemPlaceholder;
  newsItem: typeof NewsItem;
  newsDivider: typeof NewsDivider;
  button: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNews__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNews__VariantsArgs;
    args?: PlasmicNews__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicNews__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNews__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNews__ArgProps,
          internalVariantPropNames: PlasmicNews__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNews__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "newsExcerpts") {
    func.displayName = "PlasmicNews";
  } else {
    func.displayName = `PlasmicNews.${nodeName}`;
  }
  return func;
}

export const PlasmicNews = Object.assign(
  // Top-level PlasmicNews renders the root element
  makeNodeComponent("newsExcerpts"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    img: makeNodeComponent("img"),
    newsProvider: makeNodeComponent("newsProvider"),
    content2: makeNodeComponent("content2"),
    title: makeNodeComponent("title"),
    news: makeNodeComponent("news"),
    freeBox: makeNodeComponent("freeBox"),
    newsItemPlaceholder: makeNodeComponent("newsItemPlaceholder"),
    newsItem: makeNodeComponent("newsItem"),
    newsDivider: makeNodeComponent("newsDivider"),
    button: makeNodeComponent("button"),

    // Metadata about props expected for PlasmicNews
    internalVariantProps: PlasmicNews__VariantProps,
    internalArgProps: PlasmicNews__ArgProps
  }
);

export default PlasmicNews;
/* prettier-ignore-end */
